import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#5C6053]">Loading…</div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Admin accounts are for monitoring only — redirect them away from the user app
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}
